import useFlag from 'hooks/useFlag'
import { useEffect } from 'react'
import useCurrentMerchant from './useCurrentMerchant'
import useCurrentMerchantUser from './useCurrentMerchantUser'

const FORETHOUGHT_WORKFLOW_TAG = 'MerchantDashboard'
const FORETHOUGHT_SCRIPT_ID = 'forethought-widget-embed-script'

// Attribute casing (data-ft-Email, data-ft-Embed-Script-Language) is verbatim
// from Forethought's dashboard-generated snippet. Do not normalize.
const useForethought = () => {
  const isForethoughtEnabled = useFlag('forethought-in-app-chat', false)
  const merchantUser = useCurrentMerchantUser()
  const merchant = useCurrentMerchant()

  useEffect(() => {
    if (
      !isForethoughtEnabled ||
      !process.env.REACT_APP_FORETHOUGHT_API_KEY ||
      !merchantUser?.email ||
      !merchant?.id
    ) {
      return
    }

    // Injected once per page load. Switching merchants via MerchantPicker does
    // not re-inject or refresh data-ft-merchant_id; the iframe keeps its
    // original session. Matches existing useZendesk behavior. Cleanup on
    // merchant switch is a follow-up improvement (see DATA-5197 PR feedback).
    if (document.getElementById(FORETHOUGHT_SCRIPT_ID)) {
      return
    }

    const script = document.createElement('script')
    script.id = FORETHOUGHT_SCRIPT_ID
    script.src = 'https://solve-widget.forethought.ai/embed.js'
    script.async = true
    script.setAttribute(
      'data-api-key',
      process.env.REACT_APP_FORETHOUGHT_API_KEY
    )
    script.setAttribute('data-ft-Email', merchantUser.email)
    script.setAttribute('data-ft-user_id', String(merchantUser.id))
    script.setAttribute('data-ft-merchant_id', String(merchant.id))
    script.setAttribute('data-ft-Embed-Script-Language', 'en')
    script.setAttribute('data-ft-workflow-tag', FORETHOUGHT_WORKFLOW_TAG)
    document.body.appendChild(script)
  }, [
    isForethoughtEnabled,
    merchantUser?.id,
    merchantUser?.email,
    merchant?.id,
  ])
}

export default useForethought
